// Formatting for DATEONLY columns (passport startDate/endDate,
// accessOverride.expiresAt, and anything else stored as a calendar date).
//
// Postgres returns these as "2026-09-01". `new Date("2026-09-01")` parses that
// as UTC midnight, and any local formatting west of Greenwich then renders the
// day before: a passport running Sep 1-30 displayed as "August 31 - September
// 29". The date INPUT is unaffected, since it treats the string as a plain
// date, which is why the edit form looked right while the display did not.
//
// So a calendar date has to be built in local time. A value that already
// carries a time is a real instant and is passed through untouched.

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Parse a DATEONLY string as a LOCAL date. Timestamps pass through. */
export function parseDateOnly(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const m = DATE_ONLY.exec(String(value).trim());
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Format a DATEONLY value without the timezone shifting it a day. */
export function formatDateOnly(value, options = { year: 'numeric', month: 'long', day: 'numeric' }, fallback = 'N/A') {
  const d = parseDateOnly(value);
  if (!d) return fallback;
  return d.toLocaleDateString('en-US', options);
}

/** "Sep 1 - Sep 30" style range, used on the passport surfaces. */
export function formatDateOnlyRange(start, end, options = { month: 'short', day: 'numeric' }) {
  const a = parseDateOnly(start);
  const b = parseDateOnly(end);
  if (!a || !b) return '';
  return `${a.toLocaleDateString('en-US', options)} - ${b.toLocaleDateString('en-US', options)}`;
}
